const styleSheet = () => ({
  filterRadioContainer: {
    '& > div': {
      margin: '10px 0',
    },
    '& > div:first-child': {
      marginTop: '0',
    },
    '& > div:last-child': {
      marginBottom: '0',
    },
  },
  filterRadioHidden: {
    padding: '8px 4px 8px',
    paddingLeft: (props: any) =>
      (props.overrideStyles && props.overrideStyles.paddingLeft) || '4px',
  },
  filterRadioButton: {
    display: 'flex',
  },
  filterRadioLabel: {
    color: '#6373A4',
    fontFamily: "'Museo Sans', sans-serif",
    fontSize: '12px',
    fontWeight: 500,
    letterSpacing: 0,
    lineHeight: '15px',
    marginLeft: '0px',
  },
  filterHiddenContent: {
    marginTop: (props: any) =>
      (props.overrideStyles && props.overrideStyles.marginTop) || '14px',
    marginRight: (props: any) =>
      (props.overrideStyles && props.overrideStyles.marginRight) || '0',
    marginBottom: (props: any) =>
      (props.overrideStyles && props.overrideStyles.marginBottom) || '0px',
    marginLeft: (props: any) =>
      (props.overrideStyles && props.overrideStyles.marginLeft) || '24px',
    display: (props: any) =>
      ((props.selected || !props.label) && 'block') || 'none',
  },
});

export default styleSheet;
